import { combineReducers } from 'redux';
import { LOGIN, LOGOUT, GET_TOKEN, ASSINA_TERMO_CONSENTIMENTO, SAVE_STATE, DELETE_STATE, INIT } from './actions';
import { SUCCESS, ERROR,INFO, WARNING, CLEAN_MESSAGE } from './actions';
import { LOADING_ON, LOADING_OFF } from './actions';
import { SET_TERMO_CONSENTIMENTO_MAIS_RECENTE } from './actions';
import { SET_MENSAGENS_NAO_LIDAS, SET_USUARIO_CIENTE_MENSAGENS } from './actions';
import { getMenusUsuario } from './menus';
import { sessionStorageLogin } from '../utils/sessionStoreUtil';

import {PERFIL_CLIENTE, PERFIL_ADMININSTRADOR, PERFIL_AUDITOR, PERFIL_FORNECEDOR, PERFIL_FORNECEDOR_AGV, PERFIL_GESTOR_API, PERFIL_GESTOR_AGV, PERFIL_MANTENEDOR, PERFIL_ANONIMO, PERFIL_OPERADOR, PERFIL_PONTO_FOCAL} from './constPerfis';

import jwtbroken from 'jsonwebtoken';

const usuarioInitialState = {
    token: '',
    user: {},
    photo: '',
}

const mensagemInitialState = {
  mensagem: {},
  aguardando: false,
}

const termoConsentimentoInitialState = {
  termoConsentimentoMaisRecente: {},
}

const filterInitialState = {
}

const initNavigationInitialState = {
  init: false,
}

function usuarioStore(state = usuarioInitialState, action) {
    switch (action.type) {
        case LOGIN: {
            const {access_token, photo} = action;
            let user = {};

            if(access_token){
               user = jwtbroken.decode(access_token);

               if(user){
                user['isCliente'] = false;
                user['isFornecedor'] = false;
                user['isFornecedorGV'] = false;
                user['isAdministrador'] = false;
                user['isAuditor'] = false;
                user['isGestorAPI'] = false;
                user['isGestorAGV'] = false;
                user['isMantenedor'] = false;
                user['isAnonimo'] = false;
                user['isOperador'] = false;
                user['isDirigenteTi'] = false;
                user['isResponsavelTecnico'] = false;
                user['isPontoFocal'] = false;
                user['usuarioCienteMensagens'] = false;
                user['mensagensNaoLidas'] = 0;

                let fornecedor = false;
                let gestorAPI = false;

                if(user.roles){
                  if (user.roles.includes(PERFIL_CLIENTE)){
                    user['isCliente'] = true;
                    user['nomePerfil'] = 'Gestor Consumidor de API';
                  }
                  if (user.roles.includes(PERFIL_FORNECEDOR)){
                    user['isFornecedor'] = true;
                    user['nomePerfil'] = 'Gestor Fornecedor de API';
                    fornecedor = true;
                  }
                  if (user.roles.includes(PERFIL_GESTOR_API)){
                    user['isGestorAPI'] = true;
                    user['nomePerfil'] = 'Gestor de API';
                    gestorAPI = true;
                  }
                  if (user.roles.includes(PERFIL_FORNECEDOR_AGV)){
                    user['isFornecedorAGV'] = true;
                    if(fornecedor){
                      user['nomePerfil'] = user.nomePerfil + '/Arquivos GV';
                    } else {
                      user['nomePerfil'] = 'Gestor Fornecedor de Arquivos GV';
                    }
                  }
                  if (user.roles.includes(PERFIL_GESTOR_AGV)){
                    user['isGestorAGV'] = true;
                    if(gestorAPI){
                      user['nomePerfil'] = user.nomePerfil + '/AGV';
                    } else {
                      user['nomePerfil'] = 'Gestor de AGV';
                    }
                  }
                  if (user.roles.includes(PERFIL_OPERADOR)){
                    user['isOperador'] = true;
                    user['nomePerfil'] = 'Gestor Operador de API';
                  }
                  if (user.roles.includes(PERFIL_ADMININSTRADOR)){
                    user['isAdministrador'] = true;
                    user['nomePerfil'] = 'Gestor da Plataforma';
                  }
                  if (user.roles.includes(PERFIL_AUDITOR)){
                    user['isAuditor'] = true;
                    user['nomePerfil'] = 'Perfil RFB';
                  }
                  if (user.roles.includes(PERFIL_MANTENEDOR)){
                    user['isMantenedor'] = true;
                    user['nomePerfil'] = 'Perfil Serpro';
                  }
                  if (user.roles.includes(PERFIL_ANONIMO)){
                    user['isAnonimo'] = true;
                    user['nomePerfil'] = 'Sem perfil';
                  }
                  if (user.roles.includes(PERFIL_PONTO_FOCAL)){
                    user['isPontoFocal'] = true;
                  }
                  const menu = getMenusUsuario(user);
                  user['menu'] = menu;
                }
              }
            }

            sessionStorageLogin(access_token, photo);

            return {
                ...state, 
                token: access_token,
                user,
                photo,
            } 
        }
        case LOGOUT: {
            return {
                ...state,
                token: '',
                user: {},
                photo: '',
            }
        }

        case GET_TOKEN: {
          return state.token;
        }

        case ASSINA_TERMO_CONSENTIMENTO: {
          let {user} = state;
          user = {...user, assinaturaTermoPendente: false};
          return { ...state, user};
        }

        case SET_MENSAGENS_NAO_LIDAS: {
          const { mensagensNaoLidas } = action;
          let {user} = state;
          user = {...user, mensagensNaoLidas};

          return {
              ...state, 
              user,
          } 
      }

      case SET_USUARIO_CIENTE_MENSAGENS: {
          let {user} = state;
          user = {...user, usuarioCienteMensagens: true};

          return {
              ...state, 
              user,
          } 
      }

        default:
            return state
    }
}

function mensagemStore(state = mensagemInitialState, action) {
  switch (action.type) {
    case SUCCESS: 
    case ERROR:
    case INFO:
    case WARNING: {
      const {texto, erros} = action;
      if (texto || (erros && erros.length > 0)) {
        window.scrollTo(0, 0);
      }  
      return {
        ...state, 
        mensagem: {
          tipo: action.type,
          texto,
          erros,
        },
      }
    }
    case CLEAN_MESSAGE: {
      return {...state, mensagem: {},}
    }

    case LOADING_ON: {
      return {...state, aguardando: true}
    }

    case LOADING_OFF: {
      return {...state, aguardando: false}
    }

    default:
      return state
  }
}

function termoConsentimentoStore(state = termoConsentimentoInitialState, action) {
  switch (action.type) {
      case SET_TERMO_CONSENTIMENTO_MAIS_RECENTE: {
          const { termoConsentimentoMaisRecente } = action;

          return {
              ...state, 
              termoConsentimentoMaisRecente,
          } 
      }
      default:
          return state
  }
}

function filterStore(state = filterInitialState, action) {
  switch (action.type) {
      case SAVE_STATE: {
        const { path, newState } = action;

          return {
              ...state, 
              [path]: newState,
          } 
      }
      case DELETE_STATE: {
        const {path} = action;
          if (state && state[path]) {
            delete state[path];
          }
          return state;
      }
      default:
          return state
  }
}

function initNavigationStore(state = initNavigationInitialState, action) {
  switch (action.type) {
    case INIT: {
      return {
        ...state,
        init: true,
      } 
    }
    default:
          return state
  }
}

const reducers = combineReducers({
    usuarioStore,
    mensagemStore,
    termoConsentimentoStore,
    filterStore,
    initNavigationStore
})

export default reducers;